"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var form_service_1 = __importDefault(require("./form.service"));
var grid_service_1 = __importDefault(require("./grid.service"));
var group_service_1 = __importDefault(require("./group.service"));
var field_service_1 = __importDefault(require("./field.service"));
var gridfield_service_1 = __importDefault(require("./gridfield.service"));
var groupfield_service_1 = __importDefault(require("./groupfield.service"));
var groupgrid_service_1 = __importDefault(require("./groupgrid.service"));
var template_service_1 = __importDefault(require("./template.service"));
var formcontingency_service_1 = __importDefault(require("./formcontingency.service"));
/**
 * Solimat-dev-forms-builder (Swagger)
 * ====================================
 * Path: https://solimat-dev-forms-builder.azurewebsites.net
 */
var FormsBuilder = {
    Form: form_service_1.default,
    Group: group_service_1.default,
    Grid: grid_service_1.default,
    Field: field_service_1.default,
    GridField: gridfield_service_1.default,
    GroupField: groupfield_service_1.default,
    GroupGrid: groupgrid_service_1.default,
    Template: template_service_1.default,
    FormContingency: formcontingency_service_1.default
};
exports.default = FormsBuilder;
// export { default as dto } from './dto';
